import { Injectable } from '@angular/core';

import { ColorPreset } from '../model/color-preset.model';

export type CssVariable = {
  key: string;
  value: string;
};

@Injectable({ providedIn: 'root' })
export class CssVariableService {
  private readonly prefix = '--tt-color-preset';

  public setColorPresets(colorPresets: ColorPreset[], element: HTMLElement) {
    colorPresets.forEach((colorPreset) => {
      this.setCssVariable(`${this.prefix}-${colorPreset.id}-fill`, colorPreset.fill, element);
      this.setCssVariable(`${this.prefix}-${colorPreset.id}-stroke`, colorPreset.stroke, element);
      this.setCssVariable(`${this.prefix}-${colorPreset.id}-text`, colorPreset.text, element);
    });
  }

  private setCssVariable(key: string, value: string, element: HTMLElement) {
    element.style.setProperty(key, value);
  }
}
